export default __webpack_public_path__ + "static/AntIcon63-1d34202b276d86411033ba08054e8d94.png";